import { createGenericColumns, createRowsData } from "../../utils/tableUtils";

export const createCultureRowsData = createRowsData("cultureName");

export const createCultureColumns = (actions) =>
  createGenericColumns({
    nameField: "cultureName",
    nameHeader: "Nome Tipologia",
    actions,
    nameMinWidth: 200,
  });
